import Navbar from './components/navbar';
import Jumbotron from './components/jumbotron';
import Features from './components/features';
import Questions from './components/questions';
import Location from './components/location';
import About from './components/about'
import Footer from './components/footer'


function App() {
  return (
    <>
      <Navbar />
      <Jumbotron />
      <Features />
      <Questions />
      <Location />
      <About />
      <Footer />
    </>
  );
}

export default App;
